class Carousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.embla = this.querySelector('.embla__viewport');
    this.dotsContainer = this.querySelector('.embla__dots');
    this.dots = [];

    const options = { loop: false };
    this.emblaApi = EmblaCarousel(this.embla, options);
    this.emblaApi
      .on('init', this.addDots.bind(this))
      .on('reInit', this.addDots.bind(this))
      .on('init', this.toggleDotsActive.bind(this))
      .on('reInit', this.toggleDotsActive.bind(this))
      .on('select', this.toggleDotsActive.bind(this))
      .on('destroy', this.removeDots.bind(this));
  }

  addDots() {
    this.dotsContainer.innerHTML = this.emblaApi
      .scrollSnapList()
      .map(() => '<button class="embla__dot" type="button"> </button>')
      .join('');

    const scrollTo = (index) => {
      this.emblaApi.scrollTo(index);
    };

    this.dots = Array.from(this.dotsContainer.querySelectorAll('.embla__dot'));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => scrollTo(index), false);
    });
  }

  toggleDotsActive() {
    const previous = this.emblaApi.previousScrollSnap();
    const selected = this.emblaApi.selectedScrollSnap();
    this.dots[previous].classList.remove('embla__dot--selected');
    this.dots[selected].classList.add('embla__dot--selected');
  }

  removeDots() {
    this.dotsContainer.innerHTML = '';
    this.dots = [];
  }
}

customElements.define('embla-carousel', Carousel);
